import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClaimSubmissionComponent  } from './claims/claim-submission/claim-submission.component';
import { PageNotFoundComponent } from '../shared/page-not-found/page-not-found.component';
import { ClaimSubmittedComponent } from './claims/claim-submitted/claim-submitted.component';
import { RentalAndTowComponent } from './reimbursement/rental-and-tow/rental-and-tow.component';
import { ReimbursementClaimSubmittedComponent } from './reimbursement/reimbursement-claim-submitted/reimbursement-claim-submitted';

@NgModule({
  declarations: [

  ],
  imports: [
    RouterModule.forRoot([
      {
        path: 'claims/claim-submission',
        component: ClaimSubmissionComponent,
        pathMatch: 'full',
      },
      {
        path: 'claims/claim-submitted',
        component: ClaimSubmittedComponent,
        pathMatch: 'full',
      },
      {
        path: 'reimbursement/rental-and-tow',
        component: RentalAndTowComponent,
        pathMatch: 'full',
      },
      {
        path: 'reimbursement/claim-submitted',
        component: ReimbursementClaimSubmittedComponent,
        pathMatch: 'full',
      },
      { path: '',   redirectTo: 'claims/claim-submission', pathMatch: 'full' },
      { path: '**', component: PageNotFoundComponent  }  // 404 Not Found
      
    ])
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class AppRouterModule { }
